import { render, staticRenderFns } from "./FormFieldInputNumberFormattedDisplayValue.vue?vue&type=template&id=8b2a8572&"
import script from "./FormFieldInputNumberFormattedDisplayValue.vue?vue&type=script&lang=ts&"
export * from "./FormFieldInputNumberFormattedDisplayValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports